import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, IterableDiffers, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { MatDialog } from '@angular/material/dialog';
import { MemoryCardCompletionDialogComponent } from '../memory-card-completion-dialog/memory-card-completion-dialog.component';
import {
  fadeOutLeftBigAnimation,
  fadeOutRightBigAnimation,
  zoomOutLeftAnimation,
  zoomOutRightAnimation, 
} from 'angular-animations';

@Component({
  selector: 'app-memory-cards',
  templateUrl: './memory-cards.component.html',
  styleUrls: ['./memory-cards.component.css'],
  animations: [
    trigger('flipState', [
      state('active', style({
        transform: 'rotateY(179deg)'
      })),
      state('inactive', style({
        transform: 'rotateY(0)'
      })),
      state('change', style({
        transform: 'rotateY(0)'
      })),
      transition('active => inactive', animate('900ms ease-out')),
      transition('inactive => active', animate('900ms ease-in')),
      transition('change => active', animate('0ms ease-in'))
    ]),
    fadeOutLeftBigAnimation({duration: 1000}),
    fadeOutRightBigAnimation({duration: 1000}),
    zoomOutLeftAnimation(),
    zoomOutRightAnimation(),
  ]
})
export class MemoryCardsComponent implements OnInit {

  flip: string = 'inactive';
  questionsData:any;
  currentQuestionData:any;
  currentQuestionNumber:any = 0;
  isNext:any;
  isRightTransition:any;
  bookMarkedCards: any;
  toRight:any = false;
  toLeft:any = false;
  isLefZoom:any= false;
  isrightZoom:any= false;

  constructor(public selfLearnService: SelfLearnService, public spinner: NgxSpinnerService, public dialog: MatDialog, private router:Router) { }

  ngOnInit(): void {
    this.spinner.show();
    this.getMemoryCardQuestions();
 
  }

  flipCard(event:any) {
    console.log(event.target.classList[0],'flip')
    if(event.target.classList[0]!='bookmark-img' && event.target.classList[0]!= 'mem-card-chng-btn' && event.target.classList[0]!='SLV2-card-cnt-area"')
       this.flip = (this.flip == 'inactive') ? 'active' : 'inactive';
  }
  change(){
    this.flip = ""
  }


  onNext() {
    if(this.currentQuestionNumber+1<this.questionsData.length){
      this.isLefZoom = true;
      setTimeout(() => {
        this.toLeft  = true;
      this.updateCompletedMemoryCard(this.currentQuestionData.flashcardId);
      this.isNext = !this.isNext;
      this.currentQuestionData = this.questionsData[++this.currentQuestionNumber];
      this.flip = 'inactive';
      setTimeout(() => {
        this.toLeft = false;
        this.isLefZoom = false;
      }, 500);
      }, 500);

    }else{
      this.updateCompletedMemoryCard(this.currentQuestionData.flashcardId);
      this.openMemoryCardCompletionDialog();
    }
  }

  onPrevious() {
    if(this.currentQuestionNumber !=0){
      this.isrightZoom=true;
      setTimeout(() => {
      this.toRight = true;
      this.isNext = !this.isNext;
      this.isRightTransition = false;
      this.currentQuestionData = this.questionsData[--this.currentQuestionNumber];
      setTimeout(() => {
        this.toRight = false;
        this.isrightZoom = false;
      }, 500);
   
      this.flip = 'inactive';
      }, 500);

  }
  }

  getMemoryCardQuestions(){
      this.selfLearnService.getTopicsAndMemoryFlashcardsForExamChapterSubtenant().subscribe((res:any) => {
      this.questionsData = res.data.flashcards;
      this.currentQuestionData = this.questionsData[this.currentQuestionNumber];
      this.getBookmarkedMemoryCardsByChapter();

    })
  }

  bookMarkMemoryCard(event:Event){
    console.log(event);
    event.preventDefault();
    this.currentQuestionData.isBookmarked =  !this.currentQuestionData.isBookmarked;
    let payLoad:any ={
      "memoryCardId": this.currentQuestionData.flashcardId,
      "examId": this.selfLearnService.getCmsExamID(),
      "gradeId": this.selfLearnService.getGradeId(),
      "subjectId": Number(this.selfLearnService.getSubjectId()),
      "chapterId": Number(this.selfLearnService.getChapterId()),
      "chapterName": this.selfLearnService.getChapterName(),
      "isBookmarked": this.currentQuestionData.isBookmarked,
      "isCompleted": false,
      
    }
    
    this.selfLearnService.updateMemoryCardProgress(payLoad).subscribe((res:any) => {

    })
  }
  close(){
   let rounteUrl =  localStorage.getItem('previousScreen') ? localStorage.getItem('previousScreen') : 'selfLearn-V2/chapter'

   localStorage.removeItem('memoryCardQuestionId')
    this.router.navigate([rounteUrl]);
  }

  openMemoryCardCompletionDialog() {
    this.dialog.open(MemoryCardCompletionDialogComponent, { width:'500px', panelClass: 'SLV2-memorycard-completion-modal',data:{isFromMemoryCards:true} });
  }
  getBookmarkedMemoryCardsByChapter(){
    this.selfLearnService.getBookmarkedMemoryCardsByChapter().subscribe((res:any) =>{
      this.spinner.hide();
      this.bookMarkedCards = res.data;
      this.questionsData.map((item:any) =>{
        let found = this.bookMarkedCards.find((card:any) => card.memoryCardId == item.flashcardId);
        if(found){
          item.isBookmarked = true;
        }else{
          item.isBookmarked = false;
        }
      }) 
      let memoryCardId:any = localStorage.getItem('memoryCardQuestionId')
      if(memoryCardId){
       let indexNum:any = this.questionsData.findIndex((item:any) => item.flashcardId == Number(memoryCardId));
       this.currentQuestionNumber = indexNum
       this.currentQuestionData = this.questionsData[indexNum];
      }else{
        if( this.bookMarkedCards.length >0 &&  this.bookMarkedCards.length!= this.questionsData.length){
          this.currentQuestionNumber = this.bookMarkedCards.length;
          this.currentQuestionData = this.questionsData[this.currentQuestionNumber];
        }
      }

    })
  }
  updateCompletedMemoryCard(currentCardId:any){
    let payLoad:any ={
      "memoryCardId": currentCardId,
      "examId": this.selfLearnService.getCmsExamID(),
      "gradeId": this.selfLearnService.getGradeId(),
      "subjectId": Number(this.selfLearnService.getSubjectId()),
      "chapterId": Number(this.selfLearnService.getChapterId()),
      "chapterName": this.selfLearnService.getChapterName(),
      "isBookmarked": this.currentQuestionData.isBookmarked,
      "isCompleted": true
      
    }
    
    this.selfLearnService.updateMemoryCardProgress(payLoad).subscribe((res:any) => {

    })
  }
}
